import React from "react";
import LocalizedLink from "@commons/infra/i18n/LocalizedLink";

let Breadcrumbs = ({className, items = [], currentPageTitle, localize = true}) => {
    return <ol className={`breadcrumb ${className} fading-text flex-nowrap`}>
        {items.map(item => {
            return <li key={item.link} className="breadcrumb-item">
                {item.link && <LocalizedLink skipLocalization={!localize} to={item.link}>
                    {item.title}
                </LocalizedLink>}
                {!item.link && item.title}
            </li>
        })}
        {currentPageTitle && <li className="breadcrumb-item active pe-5" style={{whiteSpace: 'nowrap'}} aria-current="page">
            {currentPageTitle}
        </li>}
    </ol>;
}

export default Breadcrumbs;
